import { WORK_ORDER_STATUS_FILTER_MENU_OPTIONS } from './filters/work-order-status-filter/settings'

export const FORM_MODEL = {
  searchWorkOrderStatusInput: '',
  selectedWorkOrderStatuses: WORK_ORDER_STATUS_FILTER_MENU_OPTIONS,
  servicesOptions: [],
  searchServicesInput: '',
  selectedServices: [],
  routesOptions: [],
  searchRoutesInput: '',
  selectedRoutes: [],
  selectedDateRange: [null, null],
  isCalendarDataLoading: true,
}

export const DEFAULT_SORT_RULES_BY_SERVICE_DATE_DESC = [
  { sortDirection: 'DESC', sortField: 'SERVICE_DATE' },
  { sortDirection: 'DESC', sortField: 'WORK_ORDER_NUMBER' },
]
